webpackJsonp([72138227098318],{

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/features-bg.f8e54d21.png";

/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/features-schematic.64e8e0af.png";

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/manta-tail.c0115327.png";

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.FunnelTitle = exports.Funnel = undefined;
	
	var _glamorous = __webpack_require__(8);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _Section = __webpack_require__(20);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Funnel = (0, _glamorous2.default)(_Section2.default)(function (_ref) {
	  var _ref2;
	
	  var theme = _ref.theme,
	      _ref$glam = _ref.glam,
	      glam = _ref$glam === undefined ? {} : _ref$glam;
	  return _ref2 = {
	    background: "linear-gradient(to right, #243B55, #141E30)",
	    color: "white",
	    display: "flex",
	    flexDirection: glam.flexDirection || "row"
	  }, _ref2[theme.main.mediaQueries.mobileTablet] = {
	    flexDirection: "column",
	    textAlign: "center",
	    "&> *:not(:last-child)": {
	      marginBottom: "1.5rem",
	      padding: 0
	    }
	  }, _ref2;
	});
	
	var FunnelTitle = _glamorous2.default.h1({
	  color: "#fff",
	  margin: 0
	});
	
	exports.Funnel = Funnel;
	exports.FunnelTitle = FunnelTitle;

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(8);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	var _Section = __webpack_require__(20);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _FeatureIcons = __webpack_require__(47);
	
	var Icons = _interopRequireWildcard(_FeatureIcons);
	
	var _FeatureButton = __webpack_require__(32);
	
	var _FeatureButton2 = _interopRequireDefault(_FeatureButton);
	
	var _Hero = __webpack_require__(65);
	
	var _Funnel = __webpack_require__(48);
	
	var _mantaTail = __webpack_require__(671);
	
	var _mantaTail2 = _interopRequireDefault(_mantaTail);
	
	var _featuresBg = __webpack_require__(665);
	
	var _featuresBg2 = _interopRequireDefault(_featuresBg);
	
	var _featuresSchematic = __webpack_require__(666);
	
	var _featuresSchematic2 = _interopRequireDefault(_featuresSchematic);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroImage = _glamorous2.default.div(function (_ref) {
	  var _ref2;
	
	  var theme = _ref.theme;
	  return _ref2 = {
	    background: "url(\"" + _featuresSchematic2.default + "\") no-repeat center",
	    backgroundSize: "contain",
	    height: 300,
	    marginRight: "4rem",
	    maxWidth: 225,
	    width: "30%"
	  }, _ref2[theme.main.mediaQueries.mobile] = {
	    display: "none"
	  }, _ref2;
	});
	
	var HeroText = _glamorous2.default.div(function (_ref3) {
	  var _ref4;
	
	  var theme = _ref3.theme;
	  return _ref4 = {
	    textAlign: "left",
	    width: "50%"
	  }, _ref4[theme.main.mediaQueries.tablet] = {
	    textAlign: "left",
	    width: "60%"
	  }, _ref4[theme.main.mediaQueries.mobile] = {
	    textAlign: "center",
	    width: "75%"
	  }, _ref4;
	});
	
	var SectionContainer = _glamorous2.default.div(function (_ref5) {
	  var _ref6;
	
	  var _ref5$featurePosition = _ref5.featurePosition,
	      featurePosition = _ref5$featurePosition === undefined ? "left" : _ref5$featurePosition,
	      theme = _ref5.theme;
	  return _ref6 = {
	    display: "flex",
	    alignItems: "center",
	    flexDirection: featurePosition === "bottom" ? "column" : "row",
	    maxWidth: theme.main.maxWidths.default
	  }, _ref6[theme.main.mediaQueries.mobile] = {
	    flexDirection: featurePosition === "left" ? "column-reverse" : "column"
	  }, _ref6;
	});
	
	var SectionDescription = _glamorous2.default.div(function (_ref7) {
	  var _ref8;
	
	  var theme = _ref7.theme,
	      _ref7$glam = _ref7.glam,
	      glam = _ref7$glam === undefined ? { position: "right" } : _ref7$glam;
	  return _ref8 = {
	    paddingLeft: glam.position === "right" ? "2rem" : 0,
	    paddingRight: glam.position === "left" ? "2rem" : 0,
	    width: "45%"
	  }, _ref8[theme.main.mediaQueries.mobile] = {
	    paddingLeft: 0,
	    paddingRight: 0,
	    textAlign: "center",
	    width: "95%"
	  }, _ref8;
	});
	var SectionFeatures = _glamorous2.default.div(function (_ref9) {
	  var _ref10;
	
	  var layout = _ref9.layout,
	      theme = _ref9.theme;
	  return _ref10 = {
	    display: "flex",
	    flexDirection: layout || "column",
	    width: layout === "row" ? "100%" : "55%"
	  }, _ref10[theme.main.mediaQueries.mobile] = {
	    flexDirection: "column",
	    width: "100%"
	  }, _ref10;
	});
	
	var Feature = _glamorous2.default.div(function (_ref11) {
	  var _svg, _ref12;
	
	  var theme = _ref11.theme,
	      _ref11$layout = _ref11.layout,
	      layout = _ref11$layout === undefined ? "horizontal" : _ref11$layout,
	      _ref11$upcoming = _ref11.upcoming,
	      upcoming = _ref11$upcoming === undefined ? false : _ref11$upcoming;
	  return _ref12 = {
	    alignItems: "center",
	    border: "1px solid #eee",
	    background: "#fff",
	    borderRadius: 10,
	    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.05)",
	    display: "flex",
	    flexDirection: layout === "horizontal" ? "row" : "column",
	    flex: "0.5 1 45%",
	    margin: "1rem",
	    opacity: upcoming ? 0.5 : 1,
	    padding: "1rem",
	    transition: "0.25s",
	    ":hover": upcoming ? {} : {
	      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
	      transform: "scale(1.02, 1.02)",
	      transition: "0.25s"
	    }
	  }, _ref12[theme.main.mediaQueries.mobile] = {
	    flexDirection: "row",
	    padding: "1rem 0.75rem"
	  }, _ref12["> svg"] = (_svg = {
	    marginRight: layout === "horizontal" ? "5%" : 0,
	    width: layout === "horizontal" ? "10%" : "100%"
	  }, _svg[theme.main.mediaQueries.mobile] = {
	    marginRight: "5%",
	    width: "15%"
	  }, _svg), _ref12["> div"] = {
	    width: "85%"
	  }, _ref12;
	});
	
	var FeatureHeader = _glamorous2.default.h4({
	  alignItems: "center",
	  display: "flex",
	  justifyContent: "space-between",
	  marginBottom: "0.25rem",
	  "> small": {
	    color: "#ccc",
	    fontSize: "0.75rem",
	    textTransform: "uppercase"
	  }
	});
	
	var FeatureDescription = _glamorous2.default.small({
	  marginBottom: 0
	});
	
	var NarrowContainer = _glamorous2.default.div(function (_ref13) {
	  var theme = _ref13.theme;
	  return {
	    alignItems: "center",
	    display: "flex",
	    justifyContent: "center",
	    maxWidth: theme.main.maxWidths.default
	  };
	});
	
	var FeaturesPage = function FeaturesPage(_ref14) {
	  var onToggleContactForm = _ref14.onToggleContactForm;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Hero.Hero,
	      { glam: { background: "#BAE8CB url(\"" + _featuresBg2.default + "\") repeat" } },
	      _react2.default.createElement(
	        NarrowContainer,
	        null,
	        _react2.default.createElement(HeroImage, null),
	        _react2.default.createElement(
	          HeroText,
	          null,
	          _react2.default.createElement(
	            _Hero.HeroTitle,
	            null,
	            "Simple, but flexible"
	          ),
	          _react2.default.createElement(
	            _glamorous2.default.P,
	            { fontSize: "24px" },
	            "All the features you need, when you need them. Track cameras, multi-functional rooms, self-service printers and just about anything else."
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Section2.default,
	      null,
	      _react2.default.createElement(
	        SectionContainer,
	        { featurePosition: "left" },
	        _react2.default.createElement(
	          SectionFeatures,
	          null,
	          _react2.default.createElement(
	            Feature,
	            null,
	            _react2.default.createElement(Icons.Omnibox, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                FeatureHeader,
	                null,
	                "Omnibox"
	              ),
	              _react2.default.createElement(
	                FeatureDescription,
	                null,
	                "Find users, resources or bookings all in the same, intelligent search box."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Feature,
	            null,
	            _react2.default.createElement(Icons.Timeline, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                FeatureHeader,
	                null,
	                "Timeline"
	              ),
	              _react2.default.createElement(
	                FeatureDescription,
	                null,
	                "Understand your users' booking history and fit bookings in a tight schedule."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Feature,
	            null,
	            _react2.default.createElement(Icons.UserPortal, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                FeatureHeader,
	                null,
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "User portal"
	                )
	              ),
	              _react2.default.createElement(
	                _glamorous2.default.P,
	                { color: "#ccc", fontWeight: 100, marginBottom: 0 },
	                "(Patron-initiated reservations)"
	              ),
	              _react2.default.createElement(
	                FeatureDescription,
	                null,
	                "Let patrons make reservations without stopping by the counter. Set constraints to prevent greedy bookings and save time on both ends."
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          SectionDescription,
	          { glam: { position: "right" } },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Streamlined workflow"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Manta focuses on a light user interface that is intuitive to use and requires no training. Less clutter, faster bookings."
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Section2.default,
	      null,
	      _react2.default.createElement(
	        SectionContainer,
	        { featurePosition: "right" },
	        _react2.default.createElement(
	          SectionDescription,
	          { glam: { position: "left" } },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Flexible features"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "We know each department works differently. Forget managing three calendars, spreadsheets and pen-and-paper logs. Configure Manta to work the way you need it."
	          )
	        ),
	        _react2.default.createElement(
	          SectionFeatures,
	          null,
	          _react2.default.createElement(
	            Feature,
	            null,
	            _react2.default.createElement(Icons.AutoCirculation, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                FeatureHeader,
	                null,
	                "Auto-circulation"
	              ),
	              _react2.default.createElement(
	                FeatureDescription,
	                null,
	                "Create items that automatically check out and return. Fantastic for printers and other equipment that works by appointment."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Feature,
	            null,
	            _react2.default.createElement(Icons.ServiceHours, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                FeatureHeader,
	                null,
	                "Service Hours"
	              ),
	              _react2.default.createElement(
	                FeatureDescription,
	                null,
	                "Full control over your schedule, including holidays and seasonal changes. Set default checkout times for different resources."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Feature,
	            null,
	            _react2.default.createElement(Icons.MetaFields, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                FeatureHeader,
	                null,
	                "Meta fields"
	              ),
	              _react2.default.createElement(
	                FeatureDescription,
	                null,
	                "Store and keep track of information that you care about. Add fields detailing service history, equipment features, or anything else."
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Section2.default,
	      { css: { background: "#a9dce3" } },
	      _react2.default.createElement(
	        SectionContainer,
	        { featurePosition: "bottom" },
	        _react2.default.createElement(
	          SectionDescription,
	          { css: { width: "100%", padding: 0, maxWidth: 750, textAlign: "center" } },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Seamless integration"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Minimize the troubles of user and server management. Have us keep tabs on uptime and chat to a support team that responds in minutes."
	          )
	        ),
	        _react2.default.createElement(
	          SectionFeatures,
	          { layout: "row" },
	          _react2.default.createElement(
	            Feature,
	            { layout: "vertical" },
	            _react2.default.createElement(Icons.Cloud, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                FeatureHeader,
	                null,
	                "On the Cloud"
	              ),
	              _react2.default.createElement(
	                FeatureDescription,
	                null,
	                "No servers, passwords or infrastructure to manage. Manta takes minutes to set up, and we'll even take care of importing your resources and users."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Feature,
	            { layout: "vertical" },
	            _react2.default.createElement(Icons.SingleSignOn, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                FeatureHeader,
	                null,
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Single-sign on"
	                )
	              ),
	              _react2.default.createElement(
	                FeatureDescription,
	                null,
	                "Users should not have to create tens of accounts. Use the same sign on service your institution provides."
	              )
	            )
	          ),
	          _react2.default.createElement(
	            Feature,
	            { layout: "vertical", upcoming: true },
	            _react2.default.createElement(Icons.ActiveDirectory, null),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                FeatureHeader,
	                { css: { flexDirection: "column", alignItems: "left" } },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "Active Directory"
	                ),
	                _react2.default.createElement(
	                  _glamorous2.default.Small,
	                  { paddingTop: "0.5rem" },
	                  "Upcoming"
	                )
	              ),
	              _react2.default.createElement(
	                FeatureDescription,
	                null,
	                "Already have groups and classes created on Active Directory? Link them in directly with Manta and restrict who can book resouces that require training on enrollment."
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Section2.default,
	      { className: "integration" },
	      _react2.default.createElement(
	        SectionContainer,
	        { featurePosition: "bottom" },
	        _react2.default.createElement(
	          SectionDescription,
	          { glam: { position: "left" } },
	          _react2.default.createElement(
	            "h1",
	            null,
	            "Small and nimble"
	          ),
	          _react2.default.createElement(
	            _glamorous2.default.P,
	            { maxWidth: 750, margin: "0 auto 1.5rem" },
	            "At Manta Equipment, we value working closely with our clients, iterating fast and building a product tailored to your needs."
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Send us a message, and let us know what features you would like to see in Manta."
	          ),
	          _react2.default.createElement(_glamorous2.default.Img, { src: _mantaTail2.default })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Funnel.Funnel,
	      null,
	      _react2.default.createElement(
	        _Funnel.FunnelTitle,
	        { css: { paddingRight: "3rem" } },
	        "Try Manta Equipment now"
	      ),
	      _react2.default.createElement(
	        _FeatureButton2.default,
	        { onClick: onToggleContactForm },
	        "Arrange a demo"
	      )
	    )
	  );
	};
	
	exports.default = FeaturesPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-js-e7c0f09d8a60c4d1839a.js